const defaultElement = { id: 0, name: "", pricePerUnit: 0.00 };
const inertMaterials = { id: 1, name: "Inert materials", pricePerUnit: 0.02 };

const selectableElements = [
    { id: 2,  name: "Agricium",         pricePerUnit: 27.5  },
    { id: 3,  name: "Aluminum",         pricePerUnit: 1.33  },
    { id: 4,  name: "Beryl",            pricePerUnit: 4.41  },
    { id: 5,  name: "Bexalite",         pricePerUnit: 40.65 },
    { id: 6,  name: "Borase",           pricePerUnit: 32.58 },
    { id: 7,  name: "Copper",           pricePerUnit: 5.73  },
    { id: 8,  name: "Corundum",         pricePerUnit: 2.7   },
    { id: 9,  name: "Diamond",          pricePerUnit: 7.36  },
    { id: 10, name: "Gold",             pricePerUnit: 6.4   },
    { id: 11, name: "Hephaestanite",    pricePerUnit: 14.76 },
    { id: 12, name: "Laranite",         pricePerUnit: 31.01 },
    { id: 13, name: "Quantanium",       pricePerUnit: 88.00 },
    { id: 14, name: "Quartz",           pricePerUnit: 1.56  },
    { id: 15, name: "Taranite",         pricePerUnit: 32.58 },
    { id: 16, name: "Titanium",         pricePerUnit: 8.93  },
    { id: 17, name: "Tungsten",         pricePerUnit: 4.1   }
];

const allElements = [
    inertMaterials,
    ...selectableElements
];

export { defaultElement, inertMaterials, selectableElements };
export default allElements;